import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { Image } from '@design-system/Image';
import { Separator } from '@design-system/Separator';
import { isHexColor } from '@utils/checkHexCode';
import { cn } from '@utils/styles';

export interface StatusItem {
  id: number;
  title: string;
  rank: string;
  rank_color: string;
  description: string;
  link: string[];
}

interface NutritionStatusCardProps {
  categoryTitle: string;
  imageURL?: string;
  items?: StatusItem[];
  onClickSubCategory?: (subCategory: StatusItem | null) => void;
  cardDescription?: React.ReactNode | null;
}

const NutritionStatusCard: React.FC<NutritionStatusCardProps> = ({
  categoryTitle,
  imageURL,
  items,
  onClickSubCategory,
  cardDescription,
}) => {
  return (
    <div
      className={cn(
        'shadow-sm rounded-lg p-4 min-w-60 h-full flex flex-col justify-between',
        cardDescription ? 'bg-background-tertiary' : 'bg-white',
      )}
    >
      {/* Header Section */}
      {categoryTitle && (
        <div className="flex items-center mb-4">
          {imageURL && (
            <Image
              src={imageURL}
              width={32}
              height={32}
              alt="header icon"
              className="mr-3"
            />
          )}

          {categoryTitle && (
            <h2 className="typography-h3 text-lg font-bold line-clamp-1">
              {categoryTitle}
            </h2>
          )}
        </div>
      )}

      {/* Divider */}
      {categoryTitle && <hr className="border-stroke-primary" />}

      {cardDescription}

      {/* Items List */}
      {items?.map((item, index) => (
        <div className="mt-4 space-y-4">
          <button
            key={item?.id}
            onClick={() => onClickSubCategory?.(item)}
            className="w-full flex items-center justify-between py-2 border-b last:border-b-0 border-gray-200 text-left hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <div className="flex flex-col w-full">
              <div className="flex justify-between">
                <div>
                  <p className="typography-body font-medium line-clamp-1">
                    {item.title}
                  </p>
                  <p
                    className={`typography-caption1 font-medium`}
                    style={{
                      color: isHexColor(item?.rank_color)
                        ? item?.rank_color
                        : undefined,
                    }}
                  >
                    {item.rank}
                  </p>
                </div>
                <ChevronRightIcon className="text-gray-400" />
              </div>
              {index < items.length - 1 && (
                <Separator className="border-stroke-primary mt-4" />
              )}
            </div>
          </button>
        </div>
      ))}
    </div>
  );
};

export default NutritionStatusCard;
